import { getPrioritiesConstants } from "../constants";

export function prioritiesOrder(state = null, action) {
  if (action && action.type) {
    switch (action.type) {
      case getPrioritiesConstants.PRIORITIES_ORDERS_REQUEST:
        return {};
      case getPrioritiesConstants.PRIORITIES_ORDERS_SUCCESS:
        return { priorities: action.orders };
      case getPrioritiesConstants.PRIORITIES_ORDERS_FAILURE:
        return {};

      default:
        return state;
    }
  }
}
